// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"12":"7dd0a523416c93fd8793","777":"fac006d21cc151bf1886"}[chunkId] + ".js";
};